import React from 'react';

import { type RouteComponentProps, Redirect, Route, Switch } from 'react-router';

import LazyComponent from '@fd/ui/LazyComponent';

import { lazyWithRetry } from '../../helpers/utilities';
import ErrorBoundary from '../../layouts/Portal/ErrorBoundary';
import { PortalFeatureFlags } from '../../services/featureFlags/portalFeatureFlags';
import { useFeatureFlagValue } from '../../services/featureFlags/useFeatureFlagValue';

const EntitlementsV2MFE = lazyWithRetry(() => import('./EntitlementsV2MFE'));

type Props = RouteComponentProps<{ appId: string }>;

const EntitlementsV2Routes: React.FC<Props> = (props: Props) => {
  const {
    match: {
      path,
      params: { appId },
    },
  } = props;

  const canAccessEntitlementsV2 = useFeatureFlagValue(
    PortalFeatureFlags.accessEntitlementsV2Page,
    false
  );

  return (
    <ErrorBoundary identifier="entitlements-v2">
      <Switch>
        {canAccessEntitlementsV2 ? (
          <Route
            path={`${path}`}
            render={() => (
              <LazyComponent>
                <EntitlementsV2MFE />
              </LazyComponent>
            )}
          />
        ) : (
          <Redirect to={`/${appId}/home`} />
        )}
      </Switch>
    </ErrorBoundary>
  );
};

export default EntitlementsV2Routes;
